import { Injectable } from '@angular/core';

import { AnalyticsProps } from '@core/analytics-types';

import { AnalyticsBase } from './analytics-base';

@Injectable({ providedIn: 'root' })
export class AnalyticsGlobal extends AnalyticsBase {
  public namespace = '';
  public requireViewContext = false;

  public track(evtName: string, evtProps?: AnalyticsProps) {
    super.track(evtName, evtProps);
  }
}
